export default "__VITE_ASSET__DLegIHaf__"